import { WAIT_LOGIN, DO_LOGIN, LOGIN_SUCCESS, LOGIN_FAIL, WAIT_FORGOT_PWD, LOGIN_CLEAR_MSG, TO_OTHER_PAGE, RE_LOGIN_SUCCESS } from '../actions/login/index';

const forwardLogin = (state, action) => {
  switch (action.type) {
    case WAIT_LOGIN:
      return {
        idToken: null,
        accessToken: null,
        account: null,
        errMsg: action.loginParams.errMsg,
        status: WAIT_LOGIN,
        loading: false,
        showForgotPwd: false
      }
    case DO_LOGIN:
      return {
        idToken: null,
        accessToken: null,
        account: null,
        errMsg: null,
        status: DO_LOGIN,
        loading: true,
        showForgotPwd: false
      }
    case LOGIN_SUCCESS:
      return {
        idToken: action.loginParams.idToken,
        accessToken: action.loginParams.accessToken,
        account: action.loginParams.account,
        errMsg: null,
        status: LOGIN_SUCCESS,
        loading: false,
        showForgotPwd: false
      }
    case RE_LOGIN_SUCCESS:
      return {
        idToken: action.loginParams.idToken,
        accessToken: action.loginParams.accessToken,
        account: action.loginParams.account,
        errMsg: null,
        status: RE_LOGIN_SUCCESS,
        loading: false,
        showForgotPwd: false
      }
    case LOGIN_FAIL:
      return {
        idToken: null,
        accessToken: null,
        account: null,
        errMsg: action.loginParams.errMsg,
        status: LOGIN_FAIL,
        loading: false,
        showForgotPwd: false
      }
    case WAIT_FORGOT_PWD:
      return {
        idToken: null,
        accessToken: null,
        account: null,
        errMsg: null,
        status: WAIT_FORGOT_PWD,
        loading: false,
        showForgotPwd: true
      }
    case LOGIN_CLEAR_MSG:
      return {
        ...state,
        errMsg: null        
      }
    case TO_OTHER_PAGE: // to avoid auto show login
      return {
        ...state,
        status: TO_OTHER_PAGE
      }
    default:
      return state;
    }
}

const logindReducers = (state = {
  idToken: null,
  accessToken: null,
  account: null,
  errMsg: null,
  status: WAIT_LOGIN,
  loading: false,
  showForgotPwd: false,
}, action) => {
  switch (action.type) {
    default:
      return forwardLogin(state, action);
  }
}

export default logindReducers;